import { DashboardConnected } from 'components/dashboard/components/Dashboard';
export const DashboardView = DashboardConnected;
